<div>
  <div class="flex flex-col gap-3">
    @if (plantActions.length) {
    <section data-test="section-plants">
      <h2 class="px-1 pb-2 text-title-s text-vw-ink">{{ 'tasks.sections.plants' | translate }}</h2>
      <p class="-mt-1.5 px-1 pb-2 text-body-s text-vw-muted">{{ 'tasks.sections.plants-hint' | translate }}</p>
      <div class="divide-y divide-vw-line overflow-hidden rounded-card border border-vw-line bg-vw-surface">
        @for (action of plantActions; track action.plant.uid) {
        <vw-plant-action-row [action]="action" [checked]="checked.has(action.plant.uid)"
          (check)="onPlantChecked(action)" (open)="openPlant(action.plant)"></vw-plant-action-row>
        }
      </div>
    </section>
    }

    @if (currentTasks.length) {
    <section data-test="section-current">
      <h2 class="px-1 pb-2 text-title-s text-vw-ink">{{ 'tasks.sections.current' | translate }}</h2>
      <div class="divide-y divide-vw-line overflow-hidden rounded-card border border-vw-line bg-vw-surface">
        @for (task of currentTasks; track task.uid) {
        <vw-task [task]="task" [today]="today" [checked]="checked.has(task.uid)"
          (check)="onTaskChecked(task)" (open)="openSheet(task)"></vw-task>
        }
      </div>
    </section>
    }

    <!-- « À venir » : une ligne repliée, pas cochable ; le toucher la déplie. -->
    @let upcoming = upcomingTasks;
    @if (upcoming.length) {
    <section class="divide-y divide-vw-line overflow-hidden rounded-card border border-vw-line">
      <button type="button" data-test="upcoming-toggle" [attr.aria-expanded]="upcomingOpen" (click)="upcomingOpen = !upcomingOpen"
        class="flex min-h-12 w-full items-center gap-3 px-4 py-2 text-left text-body-s text-vw-muted">
        <svg class="h-6 w-6 shrink-0 text-vw-icon-idle" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
        <span class="flex-1"><span data-test="upcoming-title" class="font-semibold text-vw-ink">{{ 'tasks.sections.upcoming.title' | translate }}</span>, {{ (upcoming.length === 1 ? 'tasks.sections.upcoming.one' : 'tasks.sections.upcoming.many')
          | translate: { n: upcoming.length, date: upcoming[0].startDate | vwDate: 'day-month' } }}</span>
        <svg class="h-5 w-5 shrink-0 text-vw-icon-idle transition-transform" [class.rotate-180]="upcomingOpen"
          viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      @if (upcomingOpen) {
      <ul data-test="upcoming-list" class="divide-y divide-vw-line bg-vw-surface">
        @for (task of upcoming; track task.uid) {
        <li class="flex min-h-14 items-center gap-3 px-4 py-1.5">
          @if (task.gardenTask; as gesture) {
          <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-pill bg-vw-surface-tint text-title-m" aria-hidden="true">{{ emojis[gesture.category] }}</span>
          }
          <span class="min-w-0 flex-1">
            <span class="block truncate text-body font-semibold text-vw-ink">{{ task.name | Label }}</span>
            @if (task.gardenTask?.cropLabel; as crop) {
            <span class="mt-0.5 inline-block whitespace-nowrap rounded-pill bg-vw-surface-tint px-2 py-0.5 text-caption text-vw-primary-ink">{{ crop }}</span>
            }
          </span>
        </li>
        }
      </ul>
      }
    </section>
    }
  </div>

  @if (isEmpty) {
  <vw-agenda-empty messageKey="agenda.empty.current"></vw-agenda-empty>
  }

  <div class="pb-6 pt-6">
    <!-- Trois articles, puis « Voir tous » (A2) -->
    @if (!isLoading && articles.length > 0) {
    <div class="flex flex-col gap-4 mt-8 mb-28">
      <div class="flex items-baseline justify-between gap-3">
        <h2 class="text-title-l text-vw-ink">
          {{ "home.articles.title" | translate }}
        </h2>
        <button type="button" (click)="onAllArticles()" data-test="agenda-all-articles"
          class="min-h-target shrink-0 text-body-s font-semibold text-vw-primary">
          {{ 'articles.see-all' | translate }} &rsaquo;
        </button>
      </div>
      @for (article of articles; track article) {
      <vw-article [article]="article"></vw-article>
      }
    </div>
    }
  </div>

  <vw-garden-task-sheet [task]="sheetTask" [todayInfluence]="todayInfluence"
    (done)="onSheetDone()" (skip)="onSheetSkipped()" (closed)="sheetTask = null"></vw-garden-task-sheet>

  @if (pendingUndo; as undo) {
  <vw-undo-snackbar [key]="undo.key" [message]="undo.message | translate"
    (undo)="onUndo($event)" (closed)="onUndoClosed($event)"></vw-undo-snackbar>
  }
</div>
